module.exports = __webpack_public_path__ + "static/media/Electricity.e621c966.png";